(() => {
  const root = document.documentElement;
  let paused = false;
  try { paused = localStorage.getItem('boxy-motion-paused') === 'true'; } catch (_) {}
  const update = () => {
    root.dataset.boxyMotionPaused = String(paused);
    document.querySelectorAll('[data-boxy-motion-toggle]').forEach(button => {
      button.setAttribute('aria-pressed', String(paused));
      const label = button.querySelector('[data-boxy-motion-label]');
      if (label) label.textContent = paused ? button.dataset.pausedLabel : button.dataset.runningLabel;
    });
  };
  // Short greetings start when Boxy comes into view, including at the bottom of the page.
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('is-in-view', entry.isIntersecting));
  }, { threshold: .15 }) : null;
  const mount = scope => {
    scope.querySelectorAll('.boxy-site-scene:not([data-boxy-observed])').forEach(scene => {
      scene.dataset.boxyObserved = 'true';
      if (observer) observer.observe(scene); else scene.classList.add('is-in-view');
    });
    update();
  };
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-boxy-motion-toggle]')) return;
    paused = !paused;
    try { localStorage.setItem('boxy-motion-paused', String(paused)); } catch (_) {}
    update();
  });
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
